import { render, staticRenderFns } from "./minePosts.vue?vue&type=template&id=15d79245&scoped=true&"
import script from "./minePosts.vue?vue&type=script&lang=js&"
export * from "./minePosts.vue?vue&type=script&lang=js&"
import style0 from "./employ.css?vue&type=style&index=0&id=15d79245&scoped=true&lang=css&"
import style1 from "./positionList.css?vue&type=style&index=1&id=15d79245&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d79245",
  null
  
)

export default component.exports